const BARBER_AVATARS = [
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Cat",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Dog",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Fox",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Panda",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Lion",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Tiger",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Wolf",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Koala",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Bear",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Barber%20Rabbit"
];

const DOG_AVATARS = [
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Beagle",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Bulldog",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Corgi",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Dachshund",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Golden",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Husky",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Labrador",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Poodle",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Pug",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Retriever",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Samoyed",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Shepherd",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Shiba",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Terrier",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Dog%20Yorkie"
];

const CLIENT_AVATARS = [
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Cat",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Dog",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Fox",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Panda",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Lion",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Tiger",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Wolf",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Koala",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Bear",
  "https://api.dicebear.com/7.x/fun-emoji/svg?seed=Longhair%20Rabbit",
  ...DOG_AVATARS
];

const getAvatarIndex = (seed, length) => {
  if (!seed || length === 0) return 0;
  let hash = 0;
  const text = String(seed);
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash + text.charCodeAt(i) * (i + 1)) % 100000;
  }
  return hash % length;
};

const getDefaultAvatarUrl = (userType, seed) => {
  const list = userType === "barber" ? BARBER_AVATARS : CLIENT_AVATARS;
  return list[getAvatarIndex(seed, list.length)];
};

const getUserAvatarUrl = (user) => {
  if (!user) return CLIENT_AVATARS[0];
  if (user.profile_image) return user.profile_image;
  return getDefaultAvatarUrl(user.user_type, user.id || user.email || user.name);
};

const getBarbershopAvatarUrl = (barbershop) => {
  if (!barbershop) return BARBER_AVATARS[0];
  if (barbershop.profile_image) return barbershop.profile_image;
  return getDefaultAvatarUrl("barber", barbershop.id || barbershop.name);
};

export {
  BARBER_AVATARS,
  CLIENT_AVATARS,
  DOG_AVATARS,
  getDefaultAvatarUrl,
  getUserAvatarUrl,
  getBarbershopAvatarUrl
};
